import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { QaLocatorsModule } from '@metromarkets/sdk';

import { BreadcrumbsComponent } from './breadcrumbs.component';
import { HomepageNavigatorModule } from '~shared/modules/homepage-navigator/homepage-navigator.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    QaLocatorsModule,
    HomepageNavigatorModule
  ],
  declarations: [
    BreadcrumbsComponent,
  ],
  exports: [
    BreadcrumbsComponent
  ]
})

export class BreadcrumbsModule {}
